import React, { useEffect } from "react";
import "@fontsource-variable/dm-sans";
import "./steffi.css";
import "./steffi-sizing.css";
import "./phones.css";

import { WaitlistProvider } from "./components/Waitlist";
import { useSteffiCopy } from "./content";
import { usePublicLang } from "../../config/i18n/public";
import Nav from "./sections/Nav";
import Hero from "./sections/Hero";
import VoiceSection from "./sections/VoiceSection";
import AsksSection from "./sections/AsksSection";
import CallSection from "./sections/CallSection";
import ActivationSection from "./sections/ActivationSection";
import LivingBand from "./sections/LivingBand";
import AppSection from "./sections/AppSection";
import WellbeingSection from "./sections/WellbeingSection";
import LatestBlogSection from "./sections/LatestBlogSection";
import Finale from "./sections/Finale";

/* One continuous story: who Steffi is, how she is spoken to, how she keeps
   someone connected and active, and how the family stays close through the
   companion app. */
export default function SteffiHome() {
  const copy = useSteffiCopy();
  const { lang } = usePublicLang();

  useEffect(() => {
    const target = window.location.hash ? document.querySelector(window.location.hash) : null;
    if (target) {
      target.scrollIntoView();
    } else {
      window.scrollTo(0, 0);
    }
  }, []);

  /* Title and the document language follow the switcher, so screen readers and
     search engines see the language the visitor is actually reading. */
  useEffect(() => {
    const previousTitle = document.title;
    const previousLang = document.documentElement.lang;
    document.title = copy.documentTitle;
    document.documentElement.lang = lang;

    return () => {
      document.title = previousTitle;
      document.documentElement.lang = previousLang;
    };
  }, [copy.documentTitle, lang]);

  return (
    <WaitlistProvider>
      <main className="steffi">
        <Nav />
        <Hero />
        <VoiceSection />
        <AsksSection />
        <CallSection />
        <ActivationSection />
        <LivingBand />
        <AppSection />
        <WellbeingSection />
        <LatestBlogSection />
        <Finale />
      </main>
    </WaitlistProvider>
  );
}
